import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CompareContext = createContext(null);
export const useCompare = () => useContext(CompareContext);

const KEY = "suhool_compare_v1";

export function CompareProvider({ children }) {
  const [skus, setSkus] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(skus)); }, [skus]);

  const toggle = (sku, name) => {
    setSkus((prev) => {
      if (prev.includes(sku)) return prev.filter((s) => s !== sku);
      if (prev.length >= 4) { toast.error("يمكن مقارنة 4 منتجات كحد أقصى"); return prev; }
      toast.success("أُضيف للمقارنة", { description: name });
      return [...prev, sku];
    });
  };
  const remove = (sku) => setSkus((prev) => prev.filter((s) => s !== sku));
  const clear = () => setSkus([]);
  const has = (sku) => skus.includes(sku);

  return (
    <CompareContext.Provider value={{ skus, toggle, remove, clear, has }}>
      {children}
    </CompareContext.Provider>
  );
}
